import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Observable, take } from 'rxjs';

import { EnvUtils } from '@ecm/dispatcher';
import { ContextService } from '@ecm/portfolio';

import { OrangeMenuComponent } from '../../menu/components/orange-menu/orange-menu.component';
import { SoshMenuComponent } from '../../menu/components/sosh-menu/sosh-menu.component';
import { VisitorHeaderComponent } from './visitor-header/visitor-header.component';

@Component({
    selector: 'ecm-service-header',
    templateUrl: 'service-header.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [VisitorHeaderComponent, SoshMenuComponent, OrangeMenuComponent, AsyncPipe],
})
export class ServiceHeaderComponent implements OnInit {
    private readonly contextService = inject(ContextService);

    /**
     * Is authenticated or not to show visitor menu or authenticated menu
     */
    public isAuthenticated$: Observable<boolean>;

    protected isEclair = false;

    @Input()
    public isSoshMenu: boolean;

    public ngOnInit() {
        this.isAuthenticated$ = this.contextService.isAuthenticated().pipe(take(1));
        this.isEclair = EnvUtils.isEclair();
    }
}
